import createCachedSelector from 're-reselect'; // import DataConfig from '../../../data';

var gridSettingsSelector = function gridSettingsSelector(state, props) {
  return props;
};

var gridViewSelector = function gridViewSelector(state, _ref) {
  var id = _ref.id;
  return state.grid.views[id];
};

var gridDataSelector = function gridDataSelector(state, _ref2) {
  var id = _ref2.id;
  var view = state.grid.views[id] || {
    id: id
  };
  var dataKey = view.dataKey || view.id;
  return state.grid.data[dataKey] || {};
};
/**@return {import('data/types').DataListViewState} */


var getListState = function getListState(props, view, data) {
  var dataType = props.dataType;

  if (!dataType || !view) {
    return {
      data: [],
      count: 0,
      view: {
        page: 0,
        itemsPerPage: 10,
        isLoading: true,
        all: {}
      },
      dataType: dataType,
      dataProps: props.gridProps
    };
  } // let builtInType = null;
  // if (DataConfig[dataType]) builtInType = DataConfig[dataType];
  // let idKeyProp = 'Id';
  // if (builtInType && typeof builtInType.data.idKeyProp !== 'undefined')
  //   idKeyProp = builtInType.data.idKeyProp;


  var allData = view.all || {};
  var currentWindow = [];
  var crtStartIdx = view.page * view.itemsPerPage;

  for (var itemIdx = 0; itemIdx < view.itemsPerPage; itemIdx++) {
    var absoluteIdx = crtStartIdx + itemIdx;
    if (absoluteIdx >= 0 && absoluteIdx < view.count) currentWindow.push(allData[absoluteIdx]);
  }

  return {
    data: currentWindow.map(function (id) {
      if (!id) return; //loading placeholder

      return data[id];
    }),
    count: view.count || 0,
    view: view,
    dataType: dataType,
    dataProps: props.dataProps
  };
};

var selector = createCachedSelector(gridSettingsSelector, gridViewSelector, gridDataSelector, getListState)(function (state, _ref3) {
  var dataType = _ref3.dataType;
  return dataType;
});
export default selector;